"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "latisana": {
    "f9e43d72": [{
      "hkey": "00ad395e",
      "slug": "bevazzana-aprilia-marittima",
      "name": "Bevazzana-Aprilia Marittima",
      "primary": true,
      "skipSearch": false
    }],
    "aprilia-marittima": [{
      "hkey": "00ad395e",
      "slug": "bevazzana-aprilia-marittima",
      "name": "Bevazzana-Aprilia Marittima",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "latisana"
    }],
    "2475ff63": [{
      "hkey": "00ad395e",
      "slug": "bevazzana-aprilia-marittima",
      "name": "Bevazzana-Aprilia Marittima",
      "primary": true,
      "skipSearch": false
    }],
    "bevazzana": [{
      "hkey": "00ad395e",
      "slug": "bevazzana-aprilia-marittima",
      "name": "Bevazzana-Aprilia Marittima",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "194daf71": [{
      "hkey": "21eaff89",
      "slug": "latisana",
      "name": "Latisana",
      "primary": true,
      "skipSearch": false
    }],
    "latisana-mare": [{
      "hkey": "21eaff89",
      "slug": "latisana",
      "name": "Latisana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;